import React, { useState } from 'react'
import { useDefaultConsentLevel } from 'common/data/consent/get-default-consent-level'
import {
    useConsentState,
    ConsentLevel,
    acceptCookieSettingsDialog,
} from 'common/data/consent/consent.redux'
import { useDispatch } from 'react-redux'
import { hasConsentLevel } from 'common/data/consent/has-consent-level'
import { CookieConsentEvent, toCookieConsentEvent } from 'common/events/cookie-consent'

interface ConsentFormOptions {
    onEvent?: (event: CookieConsentEvent) => void
    origin: string
}

export function useConsentForm({ onEvent, origin }: ConsentFormOptions) {
    const dispatch = useDispatch()
    const defaultConsentLevel = useDefaultConsentLevel()
    const { consentLevel } = useConsentState()
    const [initialConsent] = React.useState(consentLevel || defaultConsentLevel)
    const [consent, setConsent] = useState<ConsentLevel>(initialConsent)

    function consentHandler(level: ConsentLevel) {
        const changeHandler = (changed: boolean) => {
            setConsent(changed ? consent | level : consent & ~level)
        }
        return [hasConsentLevel(consent, level), changeHandler] as const
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()

        // Raise an event
        onEvent && onEvent(toCookieConsentEvent(consent, origin))

        dispatch(acceptCookieSettingsDialog({ consentLevel: consent }))

        if (initialConsent !== consent) {
            window.location.reload()
        }
    }

    return { consentHandler, consent, handleSubmit }
}
